import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConverterService, PRODUCT_NORMALIZER } from '@spartacus/core';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Component({
    selector: 'app-kb-product-carousel',
    templateUrl: './kb-product-carousel.component.html',
    styleUrls: ['./kb-product-carousel.component.scss'],
    encapsulation: ViewEncapsulation?.None,
    standalone: false
})
export class KbProductCarouselComponent {
  @Input() product;
  constructor(private converterService:ConverterService) {}
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    nextArrow:
    "<div class='pdp-slick-nextt'><span class='pdp-icon-right-arrow-blue'></span></div>",
  prevArrow:
    "<div class='pdp-slick-prevv'><span class='pdp-icon-right-arrow-blue'></span></div>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  ngOnChanges() {        
    this.product = {
      ...this.product,
      relatedServiceItems: this.product.relatedServiceItems.map((x) => {
        return {
          ...x,
          target: this.converterService.convert(
            this.converterService.convert(x.target, PRODUCT_NORMALIZER),
            KB_PRODUCT_URL_NORMALIZER
          )
        };
      })
    };
}
}
